export const filterMenuItemsByPermissions = (items, hasAnyPermission, hasAnyRole) => {
  return items.flatMap((item) => {
    // Verify permissions
    if (item.permissions && !hasAnyPermission(item.permissions)) {
      return [];
    }

    // Verify roles
    if (item.roles && !hasAnyRole(item.roles)) {
      return [];
    }

    // If it has children, filter recursively
    if (item.children) {
      const filteredChildren = filterMenuItemsByPermissions(item.children, hasAnyPermission, hasAnyRole);

      // If no children remain after filtering, do not show the parent item
      if (filteredChildren.length === 0) {
        return [];
      }

      return [{ ...item, children: filteredChildren }];
    }

    return [item];
  });
};
